/* eslint-disable */
// Auto-generated by prebuild-scripts/fetchSSM.js. Do not edit by hand.
// Source: SSM params under /geisti/cognito/* (published by GeistiAuthStack).

const awsmobile = {
  "aws_project_region": "us-west-2",
  "aws_cognito_identity_pool_id": "us-west-2:6c6c9bd8-72cc-46b1-acd9-5c70cfaa5d96",
  "aws_cognito_region": "us-west-2",
  "aws_user_pools_id": "us-west-2_P2yhfOu5o",
  "aws_user_pools_web_client_id": "191bj2ifds8tbl8drdshc776s5",
  "oauth": {},
  "aws_mandatory_sign_in": "enable",
  "aws_cognito_username_attributes": [
    "EMAIL"
  ],
  "aws_cognito_social_providers": [],
  "aws_cognito_signup_attributes": [
    "EMAIL"
  ],
  "aws_cognito_mfa_configuration": "OFF",
  "aws_cognito_mfa_types": [],
  "aws_cognito_password_protection_settings": {
    "passwordPolicyMinLength": 8,
    "passwordPolicyCharacters": []
  },
  "aws_cognito_verification_mechanisms": [
    "EMAIL"
  ]
};

export default awsmobile;
